module.exports = __webpack_public_path__ + "media/images/clickworker_com/f2a_step_3_de-8ff2307c9dc5b8482d9d198240a0985f.png";